module.exports = "pegasus_template/assets/blocks/tile-layout-13.png";